export function formatGrade(grade: number): number {
    return Number(grade.toFixed(2));
}
